export default __webpack_public_path__ + "static/media/oct2023-3.95a9d6eb.jpeg";